import React from 'react';

import { Box, Typography } from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';

export const ObstaclesWarningContainer = ({label, styleLabel}) => {


  const styles = {
    container: {
      display: 'flex',
      alignItems: 'center',
      paddingY: '1em',
    },
    iconContainer: {
      display: 'flex',
      borderRadius: '100vh',
      border: '3px solid #000000',
      height: '1.6em',
      width: '1.6em',
      padding: '0.2em',
      justifyContent: 'center',
      alignItems: 'center',
      marginRight: '.5em',
    }, 
    labelContainer: {
      display: 'flex',
      flex: 1,
      marginTop: '.12em',
      alignItems: 'center'
    }
  };

  return (
    <Box sx={styles.container}>
      <Box aria-hidden={true} sx={styles.iconContainer}>
        <FontAwesomeIcon icon={faExclamationTriangle} />      
      </Box>
      <Box sx={styles.labelContainer}>
        <Typography sx={styleLabel}>
          {label}
        </Typography>
      </Box>
    </Box> 
  );
};